import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import NewsHeader from "../../components/NewsHeader";
import SleepyNewsAnchor from "../../components/SleepyNewsAnchor";

const NewsPage = () => (
	<Layout>
		<Seo title="October 2025" />
		<NewsHeader />
		<h2>October 2025</h2>

		<h3 className="blogdate">
			Thursday, October 30, 2025
		</h3>

		<h4 className="blogitemtitle">
			<SleepyNewsAnchor num="1">Introducing Jessellaneous</SleepyNewsAnchor>
		</h4>
		<div className="blogitembody">
			<p>
				Today some new music drops on streaming platforms: <span className="italic">Dive In</span>, originally released by Ryan Mack and Robert Grace—and now
				released by... 🥁🥁🥁... <span className="italic"><span className="bold">Jessellaneous</span></span>.
			</p>
			<p>
				I don't want to repeat myself, so I'll point to where one can already read more.
				Start with either having your first listen over at your preferred streaming platform or reading all
				about <span className="italic">Jessellaneous</span> and this new version
				of <span className="italic">Dive In</span> over <Link to="/music/18/">here</Link>.
				Or do both at the same time!
			</p>

			<p>
				I've also created a <Link to="/jessellaneous/">dedicated landing page</Link> for Jessellaneous as I expect to release more
				music under this name in the future. For now, there is a first release, appropriately called <span className="italic">one</span>,
				which includes two mixes of <span className="italic">Dive In</span>.
				What follows is the album cover.
			</p>

			<div className="main--centerwrapper p">
				<StaticImage
				src="../../images/catalog artwork/JRIVEST18 one front.jpg"
				alt="Jessellaneous - one - cover art"
				placeholder="blurred"
				layout="constrained"
				className="main--centered"
				imgClassName="img--bordered-small"
				width={500}
				/>
			</div>

			<div className="main--centerwrapper p">
			</div>

		</div>

		<p>
		<Link to="/news/">Go back to the news index page</Link>
		</p>
	</Layout>
);

export default NewsPage;
